export enum ConfirmMailAction {
  Addition = 'addition',
  Change = 'change',
  Medcard = 'medcard'
}
